import styled from 'styled-components'
import { IonInput } from '~/shared/ui/form/styled'

export const Title = styled.div`
  font-size: 18px;
  line-height: 18px;
  font-weight: 500;
  margin-bottom: 16px;
`

export const InputWrapper = styled.div``

export const ReadOnlyInput = styled(IonInput)`
  && {
    label {
      pointer-events: none;
    }
    input {
      margin-right: 26px !important;
    }
  }
`

export const ModalWrapper = styled.div`
  padding: 24px;
`

export const TitleModal = styled.div`
  font-size: 18px;
  font-weight: 500;
`

export const ButtonModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
